import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {PaymentTypeReducerType} from "./Types";
import PaymentType from "../../Models/PaymentType";
import {arrayToOptions} from "../../Utils/Utils";

const initialState: PaymentTypeReducerType = {
  paymentTypes: [],
  paymentTypesOptions: []
}

const PaymentTypeSlice = createSlice({
  name: "PaymentType",
  initialState,
  reducers: {
    getPaymentTypes(state) {},
    setPaymentTypes(state, { payload }: PayloadAction<PaymentType[]>) {
      state.paymentTypes = payload;
      state.paymentTypesOptions = arrayToOptions(payload, '_KEY', 'name');
    },
  }
});

export const PaymentTypeActions = PaymentTypeSlice.actions;

export default PaymentTypeSlice.reducer
